/*
 * Copyright (c) 2020 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { getJsonExport, LocaleProvider } from '@typescript-kit/core';

import * as texts from './text/time-clock.de.text.json';
import * as formats from './format/time-clock.de.format.json';

export class TimeClockInitializer {

  static initialize() {
    TimeClockInitializer.registerLocales();
  }

  static registerLocales() {
    LocaleProvider.registerPackageLocale('de', 'time-clock', {
      texts: getJsonExport(texts),
      formats: getJsonExport(formats)
    });
  }

}
